import React from "react";
import { useParams, Link } from "react-router-dom";
import solutionData from "../Data/solutionData";
import "../style/Solution.css";

const SolutionDetails = () => {
  const { category, id } = useParams();
  const item = solutionData[category]?.find((sol) => sol.id === id);

  if (!item) {
    return <h2>⚠ Details not found</h2>;
  }

  return (
    <div className="solution-details">
      <h2>{item.name}</h2>
      

      {/* texts List */}
      {item.texts && Array.isArray(item.texts) && (
        <>
          <h3 ></h3>
          <ul style={{maxWidth:"1300px"}}>
            {item.texts.map((text, index) => (
              <p key={index}>{text}</p>
            ))}
          </ul>
        </>
      )}


      <img src={item.imgs} alt={item.name}  style={{maxWidth: "100%", height: "auto"}} className="first-img"/>
      <p>{item.description}</p>




      {/* Features List */}
      {item.features && Array.isArray(item.features) && (
        <>
          <h3>Features:</h3>
          <ul style={{maxWidth:"1300px"}} >
            {item.features.map((feature, index) => (
              <li key={index}>{feature}</li>
            ))}
          </ul>
        </>
      )}

      {/* Applications */}
      {item.Application && Array.isArray(item.Application) && (
        <>
          <h3>Applications:</h3>
             <ul style={{maxWidth:"1300px"}} >
        {item.Application.map((item, index) => (
        <p key={index} style={{ marginBottom: "15px" }}>
          <p style={{maxWidth: "1500px"}}>{item.text} </p>
          {item.img && (
            <img src={item.img} alt={item.text} style={{display: "block",margin: "10px auto",maxWidth: "1200px",}}/>
          )}
        </p>
      ))}
    </ul>
        </>
      )}

      {/* Parameters */}
    {item.Parameters && Array.isArray(item.Parameters) && (
  <>
    <h3>Parameters:</h3>
    <ul>
      {item.Parameters.map((param, index) => (
        <li key={index}>{param}</li>
      ))}
    </ul>
  </>
)}

      <Link to={`/solution/${category}`} className="btn">
        ⬅ Back to {category} solutions
      </Link>
    </div>
  );
};

export default SolutionDetails;
